// import HomeItem from 'src/models/HomeItem';
import ProductOnline from 'src/models/ProductOnline';
import Promotion from 'src/models/Promotion';
import News from 'src/models/News';
import Product from 'src/models/Product';
import HomeItem from 'src/models/HomeItem';
import Paging from 'src/models/Paging';
import {
  getHomeOnlineProduct,
  getHomeProduct,
  getHomeBanner,
  getHomeEvent,
  login,
  getAllPromotion,
  getAllNews,
  getAllProduct,
  getAllOnlineProduct,
  getUserInfo,
} from 'src/api';
import { makeAutoObservable, runInAction } from 'mobx';
import UserInfoService from 'src/utils/UserInfoService';
import { ProductCode, ProductType } from 'src/constants';

export class HomeStore {
  homeOnlineProduct: ProductOnline[] = [];
  homeProduct: HomeItem[] = [];
  homeBanner: HomeItem[] = [];
  homeEvent: HomeItem[] = [];
  homeLoading: boolean = true;
  logining: boolean = true;
  loadingAllPromotion: boolean;
  allPromotion: Promotion[] = [];
  allNews: Paging<News>;
  loadingAllNews: boolean;
  loadingMoreAllNews: boolean;
  allOnlineProduct: ProductOnline[] = [];
  mainProduct: Product[] = [];
  supportProduct: Product[] = [];
  loadingMainProduct: boolean;
  loadingSupportProduct: boolean;
  loadingAllOnlineProduct: boolean;

  constructor() {
    makeAutoObservable(this);
  }

  setLogining = (isLogining: boolean) => {
    // console.log('setLogining', isLogining);
    this.logining = isLogining;
  };

  fetchOnlineProductHome = async () => {
    try {
      const homeOnlineProductResponse = await getHomeOnlineProduct();
      runInAction(() => {
        this.homeOnlineProduct = homeOnlineProductResponse?.data?.list;
      });
    } catch (err) {
      console.log('Home Product err', err);
    }
  };

  get cancerOnlineProduct(): ProductOnline {
    if (!this.homeOnlineProduct || this.homeOnlineProduct.length == 0)
      return null;
    return this.homeOnlineProduct.find(
      (item) => item.productCode == ProductCode.CANCER
    );
  }

  get spaOnlineProduct(): ProductOnline {
    if (!this.homeOnlineProduct || this.homeOnlineProduct.length == 0)
      return null;
    return this.homeOnlineProduct.find(
      (item) => item.productCode == ProductCode.SPA
    );
  }

  fetchProductHome = async () => {
    try {
      const homeProductResponse = await getHomeProduct();
      runInAction(() => {
        this.homeProduct = homeProductResponse?.data?.list;
      });
    } catch (err) {
      console.log('Home Product err', err);
    }
  };

  fetchBanner = async () => {
    try {
      const bannerResponse = await getHomeBanner();
      runInAction(() => {
        this.homeBanner = bannerResponse?.data?.list;
      });
    } catch (err) {
      console.log('Banner err', err);
    }
  };

  fetchHomeEvent = async () => {
    try {
      const homeEventResponse = await getHomeEvent();
      runInAction(() => {
        this.homeEvent = homeEventResponse?.data?.list;
      });
    } catch (err) {
      console.log('Home Event err', err);
    }
  };

  fetchHomeData = async () => {
    if (
      (!this.homeBanner || this.homeBanner.length == 0) &&
      (!this.homeProduct || this.homeProduct.length == 0) &&
      (!this.homeOnlineProduct || this.homeOnlineProduct.length == 0) &&
      (!this.homeEvent || this.homeEvent.length == 0)
    ) {
      runInAction(() => {
        this.homeLoading = true;
      });
    }
    const userInfoRes = await getUserInfo();
    UserInfoService.setUserInfo(userInfoRes?.data);
    await Promise.all([
      this.fetchBanner(),
      this.fetchOnlineProductHome(),
      this.fetchProductHome(),
      this.fetchHomeEvent(),
    ]);
    runInAction(() => {
      this.homeLoading = false;
    });
  };

  fetchLogin = async (loginToken: string) => {
    runInAction(() => {
      this.logining = true;
    });
    try {
      const loginRes = await login(loginToken);
      UserInfoService.setInfo(
        loginRes?.data?.access_token,
        loginRes?.data?.refresh_token,
        null,
        loginToken
      );
      const userInfoRes = await getUserInfo();
      UserInfoService.setUserInfo(userInfoRes?.data);
    } catch (err) {
      console.log('Login err', err);
    } finally {
      runInAction(() => {
        this.logining = false;
      });
    }
  };

  fetchAllPromotion = async () => {
    try {
      if (!this.allPromotion || this.allPromotion.length == 0) {
        runInAction(() => {
          this.loadingAllPromotion = true;
        });
      }
      const allPromotionResponse = await getAllPromotion();
      runInAction(() => {
        this.allPromotion = allPromotionResponse?.data?.list;
      });
    } catch (err) {
      console.log('All Promotion err', err);
    } finally {
      runInAction(() => {
        this.loadingAllPromotion = false;
      });
    }
  };

  fetchAllNews = async (pageNumber: number) => {
    try {
      if (!this.allNews || this.allNews?.list?.length == 0) {
        runInAction(() => {
          this.loadingAllNews = true;
        });
      }
      if (pageNumber > 1) {
        runInAction(() => {
          this.loadingMoreAllNews = true;
        });
      }
      const allNewsResponse = await getAllNews(pageNumber);
      console.log('All New response', allNewsResponse?.data);
      const allNewsUpdate =
        !this.allNews || pageNumber == 1
          ? {
              ...allNewsResponse?.data,
              pageNumber,
            }
          : {
              ...allNewsResponse?.data,
              list: [...this.allNews?.list, ...allNewsResponse?.data?.list],
              pageNumber,
            };
      console.log('allNewsUpdate', allNewsUpdate);
      runInAction(() => {
        this.allNews = allNewsUpdate;
        this.loadingAllNews = false;
        this.loadingMoreAllNews = false;
      });
    } catch (err) {
      console.log('AllNews err', err);
      runInAction(() => {
        this.loadingAllNews = false;
        this.loadingMoreAllNews = false;
      });
    }
  };

  fetchMainProduct = async () => {
    console.log('This that', this);
    try {
      if (!this.mainProduct || this.mainProduct.length == 0) {
        runInAction(() => {
          this.loadingMainProduct = true;
        });
      }
      const mainProductResponse = await getAllProduct(ProductType.PRODUCT_MAIN);
      runInAction(() => {
        this.mainProduct = mainProductResponse?.data?.list;
        this.loadingMainProduct = false;
      });
    } catch (err) {
      console.log('MainProduct err', err);
      runInAction(() => {
        this.loadingMainProduct = false;
      });
    }
  };

  fetchSupportProduct = async () => {
    try {
      if (!this.supportProduct || this.supportProduct.length == 0) {
        runInAction(() => {
          this.loadingSupportProduct = true;
        });
      }
      const supportProductResponse = await getAllProduct(
        ProductType.PRODUCT_SUPPORT
      );
      runInAction(() => {
        this.loadingSupportProduct = false;
        this.supportProduct = supportProductResponse?.data?.list;
      });
    } catch (err) {
      console.log('Support Product err', err);
      runInAction(() => {
        this.loadingSupportProduct = false;
      });
    }
  };

  fetchAllOnlineProduct = async () => {
    try {
      if (!this.allOnlineProduct || this.allOnlineProduct.length == 0) {
        runInAction(() => {
          this.loadingAllOnlineProduct = true;
        });
      }
      const allOnlineProductResponse = await getAllOnlineProduct();
      runInAction(() => {
        this.loadingAllOnlineProduct = false;
        this.allOnlineProduct = allOnlineProductResponse?.data?.list;
      });
    } catch (err) {
      console.log('allOnlineProduct err', err);
      runInAction(() => {
        this.loadingAllOnlineProduct = false;
      });
    }
  };
}

export default new HomeStore();
